// extracted by mini-css-extract-plugin
module.exports = {"labelWrapper":"labelWrapper___1gNIW","newLabel":"newLabel___BzGwF","foilLabel":"foilLabel___19pCZ","likeThumbnail":"likeThumbnail___KNzGI"};